module.exports = __webpack_public_path__ + "static/media/selo1.f841a299.png";